function scrollToElement(element, scrollTo) { if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: scrollTo });
} }
export { scrollToElement };
